// extracted by mini-css-extract-plugin
module.exports = {"table-pagination":"TableController_table-pagination__102kt"};